import { render } from "./uiConfirmDialog.vue?vue&type=template&id=38e0abee"
import script from "./uiConfirmDialog.vue?vue&type=script&lang=js"
export * from "./uiConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__